import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from 'process';
import { environment } from 'src/environments/environment';

const TARJETA_BLOQUEO_TIPO = [
  { id: '004', desc: 'Por la Empresa' },
  { id: '006', desc: 'Fraude o Robo' }
]
const TARJETA_REEMPLAZO_TIPO = [
  { id: 1, desc: 'Perdida' },
  { id: 2, desc: 'Robada' },
  { id: 3, desc: 'Deterioro de la Tarjeta' },
  { id: 4, desc: 'Deterioro de la Banda Magnetica' },
  { id: 5, desc: 'Reposición por Fraude' },
];

@Injectable({
  providedIn: 'root'
})
export class CacaoService {
  private api = environment.api + '/api/cacao';
  private _ihunterCacaoAccount = '0235393110592009';

  public TiposBloqueoTarjeta: any[] = TARJETA_BLOQUEO_TIPO;
  public TiposReposicionTarjeta: any[] = TARJETA_REEMPLAZO_TIPO;

  constructor(
    private http: HttpClient,
  ) { }

  getBalance() {
    return this.http.post(this.api+'/', {
      Cuenta: this._ihunterCacaoAccount
    });
  }

  ActualizarDatosCliente(_card, _user?) {
    return this.http.post(this.api + '/ActualizarDatosCliente', {
      user: _user,
      card: _card
    });
  }

  // Tarjeta
  SolicitarReposicion(_cardNumber: string, _type: any) {
    return this.http.post(this.api + '/SolicitarReposicion', {
      cardNumber: _cardNumber,
      type: _type
    });
  }
  ReasignarTarjeta(_cardNumberOld: string, _cardNumberNew: string) {
    return this.http.post(this.api + '/ReasignarTarjeta', {
      cardNumberOld: _cardNumberOld,
      cardNumberNew: _cardNumberNew
    });
  }
  ConsultarNIP(_cardNumber) {
    return this.http.post(this.api + '/ConsultarFechasValorD3', {
      cardNumber: _cardNumber,
    });
  }
  ConsultarMovimientos(_cardNumber, _dateStart, _dateEnd, _numMovements?) {
    return this.http.post(this.api + '/ConsultarMovimientosTarjeta', {
      cardNumber: _cardNumber,
      datestart: _dateStart,
      dateEnd: _dateEnd,
      numMovements: _numMovements,
    });
  }
  ConsultarTarjeta(_cardNumber) {
    return this.http.post(this.api + '/ConsultarTarjeta', {
      cardNumber: _cardNumber
    });
  }

}
